import { apiFetch, isErrorResult } from "../../../../app/apiClient.js";
import { toast } from "../../../layout/app-toast/utils/toastManager.js";
import { updateFilterOptions } from "../utils/filterManager.js";
import { currentTable } from "../../../../app/viewManager.js";
import { ensureTrackedWorkMs, getOpenTaskId } from "../../app-time/utils/timeManager.js";
import { timeToHours, hoursToTime, isOlderThan30Days, isInFuture } from "../utils/timeUtils.js";

export const getContent = () => document.querySelector("app-dialog")?.contentEl ?? null;

export function markError(element) {
    if (typeof element.setError === 'function') {
        element.setError();
    } else {
        element.style.borderColor = 'red';
        element.addEventListener('input', () => { element.style.borderColor = ''; }, { once: true });
    }
}

export async function checkTrackedHours(data, fallbackMs = null) {
    const today = new Date().toISOString().split('T')[0];
    if (data.Date !== today) return false;
    const trackedMs = await ensureTrackedWorkMs(fallbackMs);
    if (trackedMs <= 0) return false;
    const trackedHours = trackedMs / (1000 * 60 * 60);
    const existingHours = currentTable.getData()
        .filter(entry => entry.date === today && String(entry.id) !== String(data.id))
        .reduce((sum, entry) => sum + timeToHours(entry.workedHours), 0);
    const totalBookedHours = existingHours + timeToHours(data.WorkedHours);
    if (totalBookedHours > trackedHours) {
        toast(`Warnung: ${hoursToTime(totalBookedHours)} Stunden gebucht, aber nur ${hoursToTime(trackedHours)} Stunden erfasst!`, "warning");
        return true;
    }
    return false;
}
function isEmptyValue(value) {
    return !value || (Array.isArray(value) ? !value.length : String(value).trim() === "");
}

function checkMissingFields(content) {
    const requiredElements = [...content.querySelectorAll('[data-required]')];
    const missingElements = requiredElements.filter(element => {
        const value = typeof element.getValue === 'function' ? element.getValue() : element.value;
        return isEmptyValue(value);
    });

    missingElements.forEach(markError);
    return missingElements;
}

export async function validateData(data) {
    const content = getContent();
    const missingFields = content ? checkMissingFields(content) : [];

    if (data.WorkedHours === null) {
        const openTaskId = getOpenTaskId();
        if (openTaskId !== null && String(openTaskId) !== String(data.id)) {
            const hoursInput = content?.querySelector("#inputHoursWorked");
            if (hoursInput) {
                markError(hoursInput);
                if (!missingFields.includes(hoursInput)) missingFields.push(hoursInput);
            }
        }
    }

    if (missingFields.length > 0) return missingFields;

    if (data.Date){
        if (isOlderThan30Days(data.Date)) {
            const dateInput = content?.querySelector("#inputDate");
            if (dateInput) markError(dateInput);
            toast("Das Datum darf nicht mehr als 30 Tage in der Vergangenheit liegen", "error");
            return ["Date"];
        };

        if (isInFuture(data.Date)) {
            const dateInput = content?.querySelector("#inputDate");
            if (dateInput) markError(dateInput);
            toast("Das Datum darf nicht in der Zukunft liegen", "error");
            return ["Date"];
        };

    }

    if (data.Email) {
        if (!data.Email.endsWith("@cedura.de")) {
            const emailInput = content?.querySelector("#dropdownEmail");
            if (emailInput) markError(emailInput);
            toast("Die Email muss auf @cedura.de enden", "error")
            return ["Email"]
        }
    }

    return [];
}

export function removeStaleRow(result, id) {
    if (result !== 404) return false;
    currentTable.deleteRow(id);
    updateFilterOptions(currentTable.getData(), currentTable);
    return true;
}

export async function deleteRecord(resourcePath, id, successMessage, onSuccess, { idsInBody = false } = {}) {
    const ids = Array.isArray(id) ? id : [id];
    const result = idsInBody
        ? await apiFetch(resourcePath, "DELETE", ids)
        : await apiFetch(`${resourcePath}/${id}`, "DELETE");
    if (result !== 404 && isErrorResult(result)) return;

    if (currentTable) {
        ids.forEach(rowId => currentTable.deleteRow(rowId));
        updateFilterOptions(currentTable.getData(), currentTable);
    }
    if (onSuccess) onSuccess(result);
    if (result !== 404) toast(successMessage, "success");
}